import React, { useState, useEffect, useRef } from 'react';
import { 
  Shield, ShieldCheck, Briefcase, FileText, MessageSquare, Settings, Search, Bell, User, Lock, LogOut, MoreVertical, 
  Download, Upload, Plus, CheckCircle2, Clock, Eye, Layers, X, ChevronRight, ChevronLeft, 
  FilePlus2, ArrowUp, ArrowDown, CheckSquare, CalendarDays, ArrowRight, Edit, Trash2, Save, Calendar, 
  MapPin, Gavel, Users, Receipt, Banknote, RefreshCw, Mail, Sliders, ArrowDownAZ, Image as ImageIcon, FileEdit, 
  MoveUp, MoveDown, RotateCw, Settings2, Database, UserCog, Scan, Printer, MonitorDown, Copy, FolderSync, Menu, Paperclip, ExternalLink, Folder, FolderOpen, UploadCloud
} from 'lucide-react';
import { ROLE_NAMES, formatHebDate, handleDownloadLocalFile } from '../utils';

export default function HearingsView({ hearings, onEditHearing, cases, globalSearch }) {
  const [currentDate, setCurrentDate] = useState(new Date(2026, 3, 27)); 
  const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();

  const prevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  const nextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));

  const monthNames = ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"];
  const dayNames = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];

  const formatYYYYMMDD = (year, monthIndex, day) => `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

  const daysArray = [];
  for (let i = 0; i < firstDayOfMonth; i++) daysArray.push(null);
  for (let i = 1; i <= daysInMonth; i++) daysArray.push(i);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-full">
      <div className="p-4 md:p-6 border-b border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between bg-slate-50/50 gap-4">
        <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto justify-between">
          <h3 className="font-bold text-lg text-slate-800">יומן דיונים</h3>
          <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-lg border border-slate-200 shadow-sm">
             <button onClick={prevMonth} className="p-1 hover:bg-slate-100 rounded text-slate-600"><ChevronRight className="w-4 h-4" /></button>
             <span className="font-semibold text-slate-800 w-24 text-center text-sm">{monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}</span>
             <button onClick={nextMonth} className="p-1 hover:bg-slate-100 rounded text-slate-600"><ChevronLeft className="w-4 h-4" /></button>
          </div>
        </div>
        <button onClick={() => onEditHearing({ title: '', caseId: '', date: '', time: '', court: '', judge: '' })} className="w-full sm:w-auto bg-amber-600 hover:bg-amber-700 text-white px-4 py-2.5 rounded-lg text-sm font-medium flex items-center justify-center gap-2 transition-colors shadow-sm"><Plus className="w-4 h-4" /> דיון חדש ביומן</button>
      </div>
      <div className="flex-1 p-2 md:p-6 overflow-auto">
        <div className="grid grid-cols-7 gap-1 sm:gap-2 min-w-[500px]">
          {dayNames.map(day => <div key={day} className="text-center font-bold text-slate-500 text-xs md:text-sm py-2 bg-slate-50 rounded-lg border border-slate-200">{day}</div>)}
          {daysArray.map((day, idx) => {
            const dateStr = day ? formatYYYYMMDD(currentDate.getFullYear(), currentDate.getMonth(), day) : null;
            const dayHearings = hearings.filter(h => h.date === dateStr && (
              (h.title || '').includes(globalSearch || '') ||
              (h.court || '').includes(globalSearch || '') ||
              (h.judge || '').includes(globalSearch || '')
            ));
            const isToday = day === 27 && currentDate.getMonth() === 3 && currentDate.getFullYear() === 2026; 
            return (
              <div key={idx} className={`min-h-[80px] md:min-h-[120px] p-1 md:p-2 rounded-lg border transition-colors ${day ? 'bg-white hover:border-amber-300' : 'bg-transparent border-transparent'} ${isToday ? 'border-amber-400 shadow-sm' : 'border-slate-200'}`}>
                {day && (
                  <>
                    <div className={`text-xs md:text-sm font-bold mb-1 md:mb-2 w-5 h-5 md:w-7 md:h-7 flex items-center justify-center rounded-full ${isToday ? 'bg-amber-100 text-amber-700' : 'text-slate-500'}`}>{day}</div>
                    <div className="space-y-1">
                      {dayHearings.map(h => (
                        <div key={h._id} onClick={() => onEditHearing(h)} className="bg-amber-50 border border-amber-200 p-1 md:p-1.5 rounded cursor-pointer hover:bg-amber-100 transition-colors group relative" title={`${h.title} - ${h.court} - ${h.judge}`}>
                          <div className="flex justify-between items-center text-[9px] md:text-[10px] font-bold text-amber-800 mb-0.5"><span>{h.time}</span><span className="truncate pr-1 text-left hidden sm:inline" dir="ltr">{h.caseId}</span></div>
                          <p className="text-[9px] md:text-[11px] text-slate-700 font-medium truncate md:pr-4">{h.title}</p>
                          <button onClick={(e) => { e.stopPropagation(); onEditHearing(h); }} className="absolute left-1 bottom-1 text-slate-400 hover:text-blue-600 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity hidden md:block"><Edit className="w-3 h-3" /></button>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
